import * as React from "react";
import HoldLayoutDsk from "../holdLayout/holdLayoutDsk";
import { RouteChildrenProps } from "react-router-dom";
import { IHoldRouteParams } from "../../../types/components/holdings/holdTypes";
import { AGetMfHoldings } from "../../../service/holdings/holdApiService";
import { IHoldTotalBlockProps } from "../generic/holdTotalBlock";
import DeviceContext from "../../../service/indentifyDevice";
import HoldLayoutTab from "../holdLayout/holdLayoutTab";
import HoldLayoutMob from "../holdLayout/holdLayoutMob";
import HoldMfUsableTable from "../holdTables/holdMfUsableTable/holdMfUsableTable";
import HoldMfUnusableTable from "../holdTables/holdMfUnusableTable/holdMfUnusableTable";
import { EHoldScreenState } from "../holdConstants";

export interface IHoldMfContainerProps {}

export interface IHoldMfContainerState {
  holdings?: any; // if unedfined, then api is not called yet
  currentRouteParam?: IHoldRouteParams["hold"];
}

class HoldMfContainer extends React.Component<
  IHoldMfContainerProps & RouteChildrenProps<IHoldRouteParams>,
  IHoldMfContainerState
> {
  state: IHoldMfContainerState = {
    currentRouteParam: this.props.match?.params.hold,
  };

  getMfHoldingsRes = (res: any) => {
    //console.log(res);
    if (res.data) {
      this.setState({ holdings: res.data });
    } else {
      this.setState({ holdings: [] });
    }
  };

  callApi(hold?: IHoldRouteParams["hold"]) {
    if (hold === "usable" || hold === "unusable") {
      // if data is already present, then there is no need to call api again
      if (this.state.holdings === undefined) {
        AGetMfHoldings(this.getMfHoldingsRes);
      }
    }
  }

  totalBlockData(): IHoldTotalBlockProps {
    return {
      usable: this.state.holdings?.usableHld,
      unusable: this.state.holdings?.nonUsableHld,
      total: (
        +this.state.holdings?.usableHld + +this.state.holdings?.nonUsableHld
      ).toString(),
    };
  }

  showNoData(): EHoldScreenState {
    if (this.props.match?.params.hold === "usable") {
      if (this.state.holdings === undefined) {
        return EHoldScreenState.LOADING;
      }
      if (
        this.state.holdings.mfHdgUsable &&
        this.state.holdings.mfHdgUsable.length
      ) {
        return EHoldScreenState.DATA;
      }
      return EHoldScreenState.NO_DATA;
    }

    if (this.props.match?.params.hold === "unusable") {
      if (this.state.holdings === undefined) {
        return EHoldScreenState.LOADING;
      }
      if (
        this.state.holdings.nonUsable &&
        this.state.holdings.nonUsable.length
      ) {
        return EHoldScreenState.DATA;
      }
      return EHoldScreenState.NO_DATA;
    }

    return EHoldScreenState.NO_DATA;
  }

  componentDidMount() {
    // call the api initially
    this.setState({ currentRouteParam: this.props.match?.params.hold });
    this.callApi(this.props.match?.params.hold);
  }

  componentDidUpdate() {
    // call api only if route is changed
    if (this.props.match?.params.hold !== this.state.currentRouteParam) {
      this.setState({ currentRouteParam: this.props.match?.params.hold });
      this.callApi(this.props.match?.params.hold);
    }
  }

  render() {
    let child =
      this.props.match?.params.hold === "usable" ? (
        <HoldMfUsableTable
          data={
            this.state.holdings && this.state.holdings.mfHdgUsable
              ? this.state.holdings.mfHdgUsable
              : []
          }
        />
      ) : (
        <HoldMfUnusableTable
          data={
            this.state.holdings && this.state.holdings.nonUsable
              ? this.state.holdings.nonUsable
              : []
          }
        />
      );

    return DeviceContext().isDesktop ? (
      <HoldLayoutDsk
        totalBlockData={this.totalBlockData()}
        screenState={this.showNoData()}
      >
        {child}
      </HoldLayoutDsk>
    ) : DeviceContext().isTablet ? (
      <HoldLayoutTab
        totalBlockData={this.totalBlockData()}
        screenState={this.showNoData()}
      >
        {child}
      </HoldLayoutTab>
    ) : (
      <HoldLayoutMob
        totalBlockData={this.totalBlockData()}
        screenState={this.showNoData()}
      >
        {child}
      </HoldLayoutMob>
    );
  }
}

export default HoldMfContainer;
